export const OVERVIEW = "overview";
export const DETALHES = "detalhes";
export const AVALIACOES = "avaliacao";
export const SORTEIO = "sorteio";
export const PERGUNTAS = "perguntas";
export const AJUSTES = "ajustes";
export const SUPORTE = "suporte";
export const SAIR = "signin";